export default __webpack_public_path__ + "media/images/footer-logo-65cd4f42a1a9504fcbed725e219a963b.svg";